module.exports = __webpack_public_path__ + "static/media/y.496060be.png";